// Lightweight Facebook Meta Pixel helpers.
// The base pixel (init + PageView) is loaded in public/index.html.
// These helpers fire custom standard events safely (no-op if fbq is missing).

const safeFbq = (...args) => {
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    try {
      window.fbq(...args);
    } catch (err) {
      if (process.env.NODE_ENV !== "production") {
        // eslint-disable-next-line no-console
        console.warn("[fbpixel] track failed", args[0], err);
      }
    }
  }
};

export const trackLead = (params = {}) => safeFbq("track", "Lead", params);

// --- Meta CAPI helpers -------------------------------------------------

const getCookie = (name) => {
  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
};

// Collected once per submission: unique event_id + browser signals for server-side dedup.
export const getLeadTracking = () => ({
  event_id: (typeof crypto !== "undefined" && crypto.randomUUID) ? crypto.randomUUID() : `evt-${Date.now()}-${Math.random().toString(36).slice(2)}`,
  event_source_url: window.location.href,
  fbp: getCookie("_fbp"),
  fbc: getCookie("_fbc"),
});

// Browser-side Lead with the SAME eventID as the server event (Meta deduplicates).
export const trackLeadDeduped = (eventId, params = {}) =>
  safeFbq("track", "Lead", params, { eventID: eventId });

export const trackContact = (params = {}) => safeFbq("track", "Contact", params);

export const trackInitiateCheckout = (params = {}) =>
  safeFbq("track", "InitiateCheckout", params);

export const trackEvent = (name, params = {}) => safeFbq("track", name, params);
